import { JUNIOR_AGE } from '../../components/global/constants';

const moment = require('moment');

export function getExactAge(dob) {
  let age = null;
  if (!!dob) {
    const date = new Date(dob);
    const birthDate = moment(date.toISOString(), "YYYY-MM-DD");
    const today = moment();
  
    age = today.diff(birthDate, "years");
  
    if (today.isBefore(birthDate.clone().add(age, "years"))) {
      age--;
    }
  }

  return age;
}

export const checkIfJunior = (DOB) => {
    const age = getExactAge(DOB);
    return (age !== null  && age < JUNIOR_AGE) ? 'Y' : 'N';
}
